export default "__VITE_ASSET__Dniw2zol__"